import httpService from "@/services/HttpService";
import { RegisterResponse, RegisterRefiDigitalRequest } from "@/models";

const baseApiPath = process.env.VUE_APP_API_PATH || "";
export class RefiDigitalClientRegisterService {
  public async register(
    request: RegisterRefiDigitalRequest
  ): Promise<RegisterResponse> {
    const response = await httpService.axios.post<RegisterResponse>(
      baseApiPath + "/api/non-client",
      request,
    );
    return response.data;
  }
}

const refiDigitalclientRegisterService = new RefiDigitalClientRegisterService();
export default refiDigitalclientRegisterService;
